
    import {Component, Mixins} from 'vue-property-decorator'
    import IconPathsMixin from '@/components/Base/IconPathsMixin'

    @Component
    export default class MainBackground extends Mixins<IconPathsMixin>(IconPathsMixin) {
    }
